<template>
    <div class="new-banner" :class="[($i18n.locale == 'zh') ? '' : 'new-banner-hk']">
        <div class="banner-cont">
            <div class="inset-lang">
                <a :class="[($i18n.locale == 'hk') && 'current']" @click="$i18n.locale = 'hk'">繁</a>
                <span>|</span>
                <a :class="[($i18n.locale == 'zh') && 'current']" @click="$i18n.locale = 'zh'">简</a>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'hk-banner'
    }
</script>

<style scoped lang="less">
    .new-banner {
        background: url(../../static/images/allyear-banner-j.jpg) no-repeat center top/cover;
        height: 498px;
        .banner-cont {
            height: 100%;
            width: 1000px;
            margin: 0 auto;
        }
        &.new-banner-hk {
            background: url(../../static/images/allyear-banner-f.jpg) no-repeat center top/cover;
        }
        .banner-cont {
            text-align: right;
            padding-top: 30px;
        }
        .inset-lang {
            a {
                font-weight: bold;
                color: #bcbcbc;
                font-size: 14px;
                cursor: pointer;
                &.current {
                    color: #0d79cd;
                }
            }
            span {
                margin: 0 5px;
                color: #bcbcbc
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/newBanner.vue